module.exports = __webpack_public_path__ + "files/b7ecf14fce615d6fec86584ae1ae2922.svg";